import React from 'react';
import { View } from 'react-native';

import { useProviderClients } from '@/hooks/use-clients';
import { useOperationalMetrics } from '@/hooks/use-provider';
import { useTerms } from '@/hooks/use-terms';
import { ENROLLMENT_STATUS } from '@/types/enrollment-status';
import { SummaryEmpty, SummaryRow, SummarySkeleton, SummaryStat } from '../home-summary-dialog';

/** Prévia de Clientes: total, novos no mês e os últimos cadastrados. */
export function ClientsSummary() {
  const { data: metrics } = useOperationalMetrics();
  const { data: clients, isLoading } = useProviderClients();
  const terms = useTerms();

  const recent = [...(clients ?? [])]
    .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
    .slice(0, 4);

  return (
    <View className="gap-3">
      <View className="flex-row gap-2">
        <SummaryStat label="Total" value={`${metrics?.clientMetrics.total ?? 0}`} />
        <SummaryStat
          label="Novos no mês"
          value={`${metrics?.clientMetrics.newThisMonth ?? 0}`}
          tone="positive"
        />
      </View>

      {isLoading ? (
        <SummarySkeleton rows={3} />
      ) : recent.length ? (
        <View className="gap-2">
          {recent.map((client) => {
            const activeEnrollments = (client.enrollments ?? []).filter(
              (enrollment) => enrollment.status === ENROLLMENT_STATUS.ACTIVE,
            ).length;
            return (
              <SummaryRow
                key={client.id}
                icon="person-outline"
                title={client.user?.username || terms.title.client}
                description={client.phone || client.user?.email}
                value={`${activeEnrollments} ${
                  activeEnrollments === 1 ? terms.enrollment : terms.enrollmentPlural
                }`}
                valueTone="muted"
              />
            );
          })}
        </View>
      ) : (
        <SummaryEmpty
          message={`${terms.agree('Nenhum', 'client')} ${terms.client} ${terms.agree(
            'cadastrado',
            'client',
          )}.`}
        />
      )}
    </View>
  );
}
